import React from 'react';
import { Stack, Tooltip, Typography } from '@mui/material';

import { ListCard } from 'components/Card';
import { IconWrapper } from 'components/Icon';

import { DragHandle } from './DragHandle';
import { RowActions } from './RowActions';

export const RoleListItem = ({
  name,
  description,
  canDrag,
  isDragged,
  dragHandlers,
  markForEdit,
  markForDelete,
}) => {
  return (
    <ListCard
      p={1.5}
      draggable={canDrag}
      aria-label={`Role ${name}`}
      sx={{ opacity: isDragged ? 0.4 : 1, cursor: canDrag ? 'grab' : 'default' }}
      {...(canDrag && dragHandlers)}
    >
      <Stack direction="row" alignItems="center" flex={12} gap={1} minWidth={0} pl={1}>
        {canDrag && <DragHandle />}
        <Typography
          variant="body1"
          fontWeight={700}
          fontSize="1rem"
          noWrap
          sx={{ textDecoration: 'underline', cursor: 'pointer' }}
          onClick={markForEdit}
        >
          {name}
        </Typography>
        {description && (
          <Tooltip title={description}>
            <Stack aria-label={`Description of ${name}`}>
              <IconWrapper
                icon="info"
                sx={({ palette }) => ({
                  svg: { width: 20, height: 20, color: palette.grey[500] },
                })}
              />
            </Stack>
          </Tooltip>
        )}
      </Stack>

      <Stack direction="row" alignItems="center" flex={1} position="relative" minWidth={60}>
        <RowActions name={name} onEdit={markForEdit} onDelete={markForDelete} />
      </Stack>
    </ListCard>
  );
};
